// extracted by mini-css-extract-plugin
export default {"appAndroid":"appAndroid_HVymf","picture":"picture_hX8DQ"};